import { ComponentProps, FC } from 'react'
import styled from 'styled-components'

import useIsDescendantOfMap from 'hooks/useIsDescendantOfMap'

type MediaWrapperOptions = {
  portrait?: boolean
  rounded?: boolean
}

const MediaWrapper = styled.div<MediaWrapperOptions>`
  position: relative;
  overflow: hidden;
  width: 100%;

  /* aspect-ratio reserves a real height (vs the old height:0 + padding-top
     hack), so in-flow children like Embla carousels inherit a reserved height
     and their lazy images can't pop in and shift the page (CLS). */
  aspect-ratio: ${({ portrait }) => (portrait ? '4 / 5' : '18 / 13')};

  ${({ rounded = true }) =>
    rounded &&
    `
    border-radius: 6px;
  `}

  background-color: #ddd;

  transform: translate3d(0, 0, 0);
`

export const MediaWrapperOrientated: FC<
  ComponentProps<typeof MediaWrapper> & { portrait?: boolean }
> = ({ children, portrait: portraitProp, ...props }) => {
  const isDescendantOfMap = useIsDescendantOfMap()

  const portrait = portraitProp === true && isDescendantOfMap !== true

  return (
    <MediaWrapper portrait={portrait} {...props}>
      {children}
    </MediaWrapper>
  )
}

export default MediaWrapper
